const defaultSlides = 4;

const swiperSettings = {
    spaceBetween: 24,
    slidesPerView: 1.5,
    breakpointsInverse: true,
    loopAdditionalSlides: 3,
    loopedSlides: 3,
    observer: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
        768: {
            spaceBetween: 20,
            slidesPerView: 2.5
        },
        992: {
            spaceBetween: 28,
            slidesPerView: defaultSlides
        }
    }
};

const swiperPagHtml = '<div class="swiper-button swiper-button-next" tabindex="0" role="button" aria-label="Next slide">' +
'<span class="swiper-button-next-icon icon-arrow-black-left"></span></div>' +
'<div class="swiper-button swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide">' +
'<span class="swiper-button-prev-icon icon-arrow-black-left"></span></div>';

/**
* Clone an object by serializing it and deserializing it
* @param {Object} src - object to clone
* @returns {Object} cloned object
*/
function jsonClone(src) {
    return JSON.parse(JSON.stringify(src));
}

module.exports = {
    load: function () {
        const $related = $('.product-carousel');
        const $products = $related.find('.product');
        const unavailable = !$products.length;

        if (unavailable) return;

        $products.addClass('swiper-slide');

        const settings = jsonClone(swiperSettings); // clone settings to prevent modifying general settings

        const slidesPerView = parseInt($related.attr('data-slides'), 10) || defaultSlides;
        settings.breakpoints[992].slidesPerView = slidesPerView;

        if ($products.length > slidesPerView) {
            $related.after(swiperPagHtml);
            settings.loop = true;
            settings.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            };
        } else {
            settings.loop = false;
        }

        new Swiper('.product-carousel', settings); // eslint-disable-line no-new

        $related.show();
    },
    loadAdobeRecommendationsCarousel: function () {
      $('body').on('AdobeRecommendations:Loaded', function (event, data) {
            const $adobe = $('.adobe-recommendations');
            const $products = $adobe.find('.product');
            const unavailable = !$products.length;

            if (unavailable) return;

            $products.addClass('swiper-slide');

            const settings = jsonClone(swiperSettings); // clone settings to prevent modifying general settings

            settings.breakpoints[992].slidesPerView = data.maxSlides;

            if ($products.length > data.maxSlides) {
                $adobe.after(swiperPagHtml);
                settings.loop = true;
                settings.navigation = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                };
            } else {
                settings.loop = false;
            }

            new Swiper('.adobe-recommendations', settings); // eslint-disable-line no-new

            $adobe.show();
        });
    }
};
